import axios from '../../http'

class XBProduct {
  // xb根据id获取商品详情
  postXBProductDetail(id, pId) {
    const url = `/api/xb/goods/get?id=${id}&pId=${pId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb添加收藏夹
  getXBAddCollection(id) {
    const url = `/api/xb/collection/add?goodsId=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb取消关注
  getXBCancelCollection(id) {
    const url = `api/xb/collection/cancel/care?goodsId=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据sku的Id和送货地址获取本地仓和总仓的数量
  getSaleNum(id, city, region) {
    const url = `/api/xb/goods/get/num?goodsId=${id}&city=${city}&region=${region}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb根据id获取套餐
  postXBPackage(goodsId) {
    const url = `/api/index/set/meal/list?goodsId=${goodsId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //购买样品订单确认页面
  postSample(data) {
    const url = `/api/xb/order/info`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBProduct;
